export default __webpack_public_path__ + "static/media/12.b120ba13.txt";